import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Lock, Zap } from 'lucide-react';

export const PaywallDialog = ({ open, onOpenChange }) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="w-12 h-12 rounded-full bg-amber-500/20 flex items-center justify-center mx-auto mb-2">
            <Lock className="w-6 h-6 text-amber-400" />
          </div>
          <DialogTitle className="text-center">Plan requerido</DialogTitle>
          <DialogDescription className="text-center">
            Para guardar cambios o crear proyectos necesitas un plan activo.
            El proyecto demo es solo de lectura.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-4">
          <Button 
            onClick={() => { onOpenChange(false); navigate('/pricing'); }}
            className="w-full gap-2 bg-gradient-to-r from-blue-500 to-cyan-500"
            data-testid="paywall-upgrade-btn"
          >
            <Zap className="w-4 h-4" />
            Ver Planes desde $14 USD/mes
          </Button>
          <Button 
            onClick={() => onOpenChange(false)} 
            variant="ghost" 
            className="w-full"
            data-testid="paywall-close-btn"
          >
            Seguir explorando
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
